<div
  id="device-info-map-table-container"
  class="matp-table-container tw-h-full"
>
  <div class="matp-table-area">
    <table
      id="device-info-map-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <!-- デバイス名 -->
      <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            デバイス名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="deviceNameFilter"
              type="text"
              [(ngModel)]="deviceNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="devicename-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDeviceNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="deviceName" mat-cell *matCellDef="let element" #row>
          <a
            [routerLink]="['/device-info', element.serialNo]"
            [queryParams]="{ page: 'device-info' }"
          >
            {{ element.deviceName }}
          </a>
        </td>
      </ng-container>

      <!-- シリアル番号 -->
      <ng-container matColumnDef="serialNo">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            シリアル番号
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="serialNoFilter"
              type="text"
              [(ngModel)]="serialNoKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="serialno-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearSerialNoFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="serialNo" *matCellDef="let element">
          {{ element.serialNo }}
        </td>
      </ng-container>

      <!-- タグ -->
      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            タグ
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="tagFilter"
              type="text"
              [(ngModel)]="tagKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tag-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTagFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="tag" *matCellDef="let element" class="tw-w-[360px]">
          <div *ngFor="let tag of element.tagList" class="tw-inline-block">
            <mat-card
              class="tw-m-2 tw-p-1 !tw-inline-block"
              [ngStyle]="tagStyle(tag.color)"
              >{{ tag.tagName }}</mat-card
            >
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (mouseenter)="onMouseEnter($event)"
        (mouseleave)="onMouseLeave($event)"
        (click)="selectDevice(row)"
        [ngClass]="{
          '!tw-bg-black/[.04]': selectedRow?.serialNo === row.serialNo,
        }"
        #row
      ></tr>
    </table>
  </div>
</div>
